import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserGamificationAggregate = () => {
    const { reportData } = useContext(ReportContext);

    const {
        userXpTotal,
        userXpByCategory,
        totalSproutsEarned,
        sproutsEarnedByCategory,
        totalSproutsRedeemed,
        sproutsRedeemedByEntrySize,
    } = reportData;

    const groupedColumns = [
        {
            field: 'group',
            name: 'Category',
            dataType: 'multiselect',
            styles: { minWidth: '18rem' },
        },
        {
            field: 'total',
            name: 'Total',
            dataType: 'numeric',
        },
    ];

    const redeemedColumns = [
        {
            field: 'group',
            name: 'Entry Size',
            dataType: 'multiselect',
            styles: { minWidth: '14rem' },
        },
        {
            field: 'total',
            name: 'Total',
            dataType: 'numeric',
        },
    ];

    return (
        <div className="space-y-6">
            {/* XP Section */}
            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">XP</h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem label="Total XP:" value={userXpTotal} />
                </SimpleDataGrid>
                <StandardizedDataTable data={userXpByCategory} columns={groupedColumns} />
            </div>

            {/* Sprouts Earned Section */}
            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">Sprouts Earned</h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Total Sprouts Earned:"
                        value={totalSproutsEarned}
                    />
                </SimpleDataGrid>
                <StandardizedDataTable
                    data={sproutsEarnedByCategory}
                    columns={groupedColumns}
                />
            </div>

            {/* Sprouts Redeemed Section */}
            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">Sprouts Redeemed</h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Total Sprouts Redeemed:"
                        value={totalSproutsRedeemed}
                    />
                </SimpleDataGrid>
                <StandardizedDataTable
                    data={sproutsRedeemedByEntrySize}
                    columns={redeemedColumns}
                />
            </div>

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of gamification metrics
                    including XP (Experience Points) and Sprouts earned and redeemed
                    within the platform for the selected time period and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="XP (Experience Points)">
                    Points earned by users for completing various activities throught the
                    site such as reading content, completing courses, writing journals,
                    etc. XP is broken down by category to show which areas users are most
                    engaged with.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sprouts Earned">
                    Rewards earned by users for completing Tasks assigned on the user's
                    dashboard and reaching login streak goals.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sprouts Redeemed">
                    The total number of Sprouts users have spent on entries into our
                    monthly sweepstakes. These are categorized by the number of entries
                    bought.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserGamificationAggregate;
